import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getDetail } from '@api/setting/task/create';
import { getStrucName as _getStrucName } from '@/util';
import { mapState } from 'vuex';
export default {
  name: 'task-info',
  props: {
    id: {
      required: true
    }
  },
  computed: _objectSpread({}, mapState('cpscc', ['levelKey'])),
  data: function data() {
    return {
      loading: false,
      init: false,
      form: {
        c01CreateStaff: undefined,
        c01CusName: '',
        c01CusShortName: '',
        c01CusInfo: '',
        c01StrucCode: undefined,
        c01StartDate: undefined,
        c01EndDate: undefined,
        c01N01Code: undefined,
        c01RiskLevel: undefined,
        c01QCLevel: undefined,
        c01StrucType: undefined,
        c01TaskName: '',
        c01ReportNeed: undefined,
        c01ReportDate: undefined,
        c01OfficeName: '',
        c01ReportMapping: undefined,
        leaders: undefined,
        managers: undefined,
        partners: undefined,
        quality4: undefined,
        quality5: undefined,
        inquisitor: undefined,
        participants: undefined,
        c01IsPublic: false,
        c01CreateStaffName: undefined,
        c01CreateDate: undefined,
        c01FileState: undefined,
        c01TaskState: undefined,
        c01UpTaskId: ''
      }
    };
  },
  methods: {
    show: function show(value) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      if (!this.init) {
        this.getData();
      }
    },
    getStrucName: function getStrucName(code) {
      return _getStrucName(code);
    },
    getData: function getData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, data, form, staffDetails, staffType;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.loading = true;
              _context.n = 1;
              return _this.$awaitTo(getDetail({
                TaskId: _this.id
              }));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              data = _yield$_this$$awaitTo2[1];
              _this.loading = false;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              form = data.data1.taskInfo;
              staffDetails = data.data1.staffDetails;
              if (Array.isArray(staffDetails) && staffDetails.length) {
                staffType = _this.levelKey;
                staffDetails.forEach(function (item) {
                  if (staffType[item.c11Role]) {
                    if (!Array.isArray(form[staffType[item.c11Role]])) {
                      form[staffType[item.c11Role]] = [item.c11Name];
                    } else {
                      form[staffType[item.c11Role]].push(item.c11Name);
                    }
                  }
                });
              }
              _this.form = form;
              _this.init = true;
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getStaffName: function getStaffName(ids) {
      if (Array.isArray(ids) && ids.length) {
        return ids.join('、');
      }
      return '';
    }
  }
};